import React, { useState, useEffect } from 'react'
import * as R from 'ramda'
import { useHistory } from 'react-router-dom'

import { connect } from 'react-redux'
import { partyLogin, partyLoginDirectly } from '../actions/party'

import { Row, Col, Button, Spin } from 'antd'

// import PartyBackArrow from '../components/PartyBackArrow'
import PartyLoginForm from './PartyLoginForm'
import PartyPopUp from './PartyPopUp'
import PartyFooterBg from './PartyFooterBg'
import config from '../config'

import sunImg from '../assets/images/img_sun_cloud.png'
import cloudImg from '../assets/images/img_cloud_1.png'

const imgBaseUrl = config.firebase.getImageUrl()

const gameTitleImg = `${imgBaseUrl}/Party%2Fimg_game_title_bg.png?alt=media`
const upperBgImg = `${imgBaseUrl}/Party%2Fimg_party_upper_bg.png?alt=media`
const footerBgImg = `${imgBaseUrl}/Party%2Fimg_party_footer_bg.png?alt=media`
const footerElementImg = `${imgBaseUrl}/Party%2Fimg_party_footer_element.png?alt=media`

export function PartyLogin(props) {
    const history = useHistory()
    const { nickname, invite, end } = props

    const scrollHeight = document.documentElement.scrollHeight
    const clientHeight = document.documentElement.clientHeight
    const footerBgHeight = R.min(scrollHeight - 443, 1367)

    const [popUpState, setPopUpState] = useState(false)
    const [top, setTop] = useState(`${clientHeight}px`)

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            setTop(`${scrollHeight - footerBgHeight - currentScrollY}px`)
        }

        window.addEventListener("scroll", handleScroll, { passive: true })

        return () => window.removeEventListener("scroll", handleScroll)
    }, [top])

    useEffect(() => {
        window.scroll(0, 1)
    }, [])

    useEffect(() => {
        if (props.loginSuccess) {
            history.replace(`/party/upload`)
        }
    }, [props.loginSuccess])

    const handleLogin = (values) => {
        props.partyLogin({
            ...values,
            partyId: props.partyInfo.partyId,
            name: nickname,
        })
    }

    const handleLoginDirectly = () => {
        props.partyLoginDirectly({
            partyId: props.partyInfo.partyId,
        })
    }

    const createMarkup = (props) => {
        let str = String(props)
        let re = /(\r\n)|(\n)/g
        let reLink = /(https?:\/\/[\w\-/.?=&#]+)/g
        let newStr = str.replace(re, "<br>").replace(reLink, "<a href='$1' target='_blank'>$1</a>")

        return { __html: newStr }
    }

    return (
        <div>
            {/* Loading */}
            <Row
                type="flex"
                justify="center"
                align="middle"
                className={props.isLoggingIn ? "party-loading" : "web-hidden"}
            >
                <Spin tip="Loading..." />
            </Row>

            {/* Backgrond */}
            <div className="party-login-upper-frame">
                <img src={upperBgImg} className="party-login-bg-img" alt="background" />
            </div>

            <img src={sunImg} className="party-login-sun-img" alt="sun" />
            <img src={cloudImg} className="party-login-cloud-img" alt="cloud" />

            <PartyFooterBg top={top} height={footerBgHeight}>{footerBgImg}</PartyFooterBg>

            {/* Back arrow (Void) */}
            {/* <PartyBackArrow /> */}

            {/* Pop up */}
            <PartyPopUp popUpState={popUpState} setPopUpState={setPopUpState} />

            {/* Title */}
            <Row type="flex" justify="start" className="party-login-title-frame">
                <img src={gameTitleImg} className="web-img" alt="title" />
                <p className="party-login-title-font">{props.partyInfo.title}</p>
            </Row>

            {/* Login */}
            {/* Invite-only */}
            <div className={invite ? "party-login-frame" : "web-hidden"}>
                <Row>
                    <p className="party-login-hint">輸入報名時的 <b>身分證字號</b> 與 <b>手機號碼</b> </p>
                </Row>

                <PartyLoginForm handleLogin={handleLogin} end={end} />
            </div>

            {/* Not invitation system */}
            <div className={!invite ? "party-login-frame" : "web-hidden"}>
                <Button
                    className={!end ? "party-login-btn" : "web-hidden"}
                    onClick={() => handleLoginDirectly()}
                >
                    進入競賽
                </Button>

                <Button
                    className={end ? "party-login-btn" : "web-hidden"}
                    disabled
                >
                    已無法報名
                </Button>
            </div>

            {/* Rule */}
            <Row type="flex" justify="center" className="party-login-rule-frame">
                <Col span={24}>
                    <p className="party-login-rule-title">競賽規則</p>
                </Col>

                <Col className="party-login-rule-content">
                    <div dangerouslySetInnerHTML={createMarkup(props.partyInfo.description)} id="rule-content"></div>
                </Col>
            </Row>

            {/* Footer image */}
            <div className="party-login-footer-image-frame">
                <img src={footerElementImg} className="web-img" alt="footer" />
            </div>

        </div>
    )
}

const mapStateToProps = state => ({
    partyInfo: state.party.partyInfo,
    loginSuccess: state.party.loginSuccess,
    isLoggingIn: state.party.isLoggingIn,
});

const mapDispatchToProps = {
    partyLogin,
    partyLoginDirectly,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PartyLogin)